import tags from '../tags';

const {
  elements: { poison, cold, physical, fire },
  skillTypes: {
    cc,
    dot,
    pet,
    cooldown,
    channeling,
    mobility,
    healing,
    toughness,
    damageBoost,
    resource,
    weaken,
  },
  skillTrees: { primary, secondary, defensive, terror, decay, voodoo },
} = tags;

export default [
  {
    name: 'Poison Dart',
    runes: [
      {
        name: 'No Rune',
        tags: [poison, primary],
      },
      {
        name: 'Splinters',
        tags: [poison, primary],
      },
      {
        name: 'Numbing Dart',
        tags: [cold, cc, primary],
      },
      {
        name: 'Spined Dart',
        tags: [physical, primary],
      },
      {
        name: 'Flaming Dart',
        tags: [fire, dot, primary],
      },
      {
        name: 'Snake to the Face',
        tags: [poison, cc, primary],
      },
    ],
  },
  {
    name: 'Grasp of the Dead',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, cooldown, cc, secondary],
      },
      {
        name: 'Unbreakable Grasp',
        tags: [cold, cooldown, cc, secondary],
      },
      {
        name: 'Groping Eels',
        tags: [physical, cooldown, cc, secondary],
      },
      {
        name: 'Death Is Life',
        tags: [poison, cooldown, cc, secondary],
      },
      {
        name: 'Desperate Grasp',
        tags: [poison, cooldown, cc, secondary],
      },
      {
        name: 'Rain of Corpses',
        tags: [physical, cooldown, cc, secondary],
      },
    ],
  },
  {
    name: 'Corpse Spiders',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, primary],
      },
      {
        name: 'Leaping Spiders',
        tags: [poison, primary],
      },
      {
        name: 'Spider Queen',
        tags: [poison, dot, primary],
      },
      {
        name: 'Widowmakers',
        tags: [physical, primary],
      },
      {
        name: 'Medusa Spiders',
        tags: [cold, cc, primary],
      },
      {
        name: 'Blazing Spiders',
        tags: [fire, primary],
      },
    ],
  },
  {
    name: 'Summon Zombie Dogs',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, pet, defensive],
      },
      {
        name: 'Rabid Dogs',
        tags: [poison, dot, pet, defensive],
      },
      {
        name: 'Chilled to the Bone',
        tags: [cold, cc, pet, defensive],
      },
      {
        name: 'Life Link',
        tags: [physical, pet, defensive, toughness],
      },
      {
        name: 'Burning Dogs',
        tags: [fire, pet, defensive],
      },
      {
        name: 'Leeching Beasts',
        tags: [physical, pet, defensive, healing],
      },
    ],
  },
  {
    name: 'Firebats',
    runes: [
      {
        name: 'No Rune',
        tags: [fire, channeling, secondary],
      },
      {
        name: 'Dire Bats',
        tags: [fire, channeling, secondary],
      },
      {
        name: 'Vampire Bats',
        tags: [physical, channeling, secondary],
      },
      {
        name: 'Plague Bats',
        tags: [poison, channeling, secondary],
      },
      {
        name: 'Hungry Bats',
        tags: [fire, channeling, secondary],
      },
      {
        name: 'Cloud of Bats',
        tags: [fire, channeling, secondary],
      },
    ],
  },
  {
    name: 'Horrify',
    runes: [
      {
        name: 'No Rune',
        tags: [cc, cooldown, defensive, physical],
      },
      {
        name: 'Phobia',
        tags: [cc, cooldown, defensive, physical],
      },
      {
        name: 'Stalker',
        tags: [cc, cooldown, defensive, mobility, physical],
      },
      {
        name: 'Face of Death',
        tags: [cc, cooldown, defensive, physical],
      },
      {
        name: 'Frightening Aspect',
        tags: [cc, cooldown, defensive, toughness, physical],
      },
      {
        name: 'Ruthless Terror',
        tags: [cc, cooldown, defensive, physical],
      },
    ],
  },
  {
    name: 'Soul Harvest',
    runes: [
      {
        name: 'No Rune',
        tags: [damageBoost, terror, physical],
      },
      {
        name: 'Swallow Your Soul',
        tags: [damageBoost, resource, terror, poison],
      },
      {
        name: 'Siphon',
        tags: [damageBoost, healing, terror, physical],
      },
      {
        name: 'Languish',
        tags: [damageBoost, toughness, terror, cold],
      },
      {
        name: 'Soul to Waste',
        tags: [damageBoost, mobility, terror, fire],
      },
      {
        name: 'Vengeful Spirit',
        tags: [damageBoost, physical, terror, physical],
      },
    ],
  },
  {
    name: 'Plague of Toads',
    runes: [
      {
        name: 'No Rune',
        tags: [poison, primary],
      },
      {
        name: 'Explosive Toads',
        tags: [fire, primary],
      },
      {
        name: 'Piercing Toads',
        tags: [physical, primary],
      },
      {
        name: 'Rain of Toads',
        tags: [poison, dot, primary],
      },
      {
        name: 'Addling Toads',
        tags: [poison, cc, primary],
      },
      {
        name: 'Toad Affinity',
        tags: [cold, primary, resource],
      },
    ],
  },
  {
    name: 'Haunt',
    runes: [
      {
        name: 'No Rune',
        tags: [cold, dot, secondary],
      },
      {
        name: 'Consuming Spirit',
        tags: [fire, healing, dot, secondary],
      },
      {
        name: 'Resentful Spirits',
        tags: [cold, dot, secondary],
      },
      {
        name: 'Lingering Spirit',
        tags: [cold, dot, secondary],
      },
      {
        name: 'Poisoned Spirit',
        tags: [poison, weaken, dot, secondary],
      },
      {
        name: 'Draining Spirit',
        tags: [physical, resource, dot, secondary],
      },
    ],
  },
  {
    name: 'Sacrifice',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, terror],
      },
      {
        name: 'Black Blood',
        tags: [physical, cc, terror],
      },
      {
        name: 'Next of Kin',
        tags: [physical, terror],
      },
      {
        name: 'Pride',
        tags: [physical, resource, terror],
      },
      {
        name: 'For the Master',
        tags: [physical, terror],
      },
      {
        name: 'Provoke the Pack',
        tags: [physical, terror, damageBoost],
      },
    ],
  },
  {
    name: 'Zombie Charger',
    runes: [
      {
        name: 'No Rune',
        tags: [poison, decay],
      },
      {
        name: 'Pile On',
        tags: [physical, decay],
      },
      {
        name: 'Undeath',
        tags: [poison, decay],
      },
      {
        name: 'Lumbering Cold',
        tags: [cold, decay],
      },
      {
        name: 'Explosive Beast',
        tags: [fire, decay],
      },
      {
        name: 'Zombie Bears',
        tags: [poison, decay],
      },
    ],
  },
  {
    name: 'Spirit Walk',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, mobility, physical],
      },
      {
        name: 'Jaunt',
        tags: [defensive, mobility, physical],
      },
      {
        name: 'Honored Guest',
        tags: [defensive, resource, mobility, physical],
      },
      {
        name: 'Umbral Shock',
        tags: [fire, defensive, mobility],
      },
      {
        name: 'Severance',
        tags: [defensive, mobility, physical],
      },
      {
        name: 'Healing Journey',
        tags: [defensive, healing, mobility, physical],
      },
    ],
  },
  {
    name: 'Spirit Barrage',
    runes: [
      {
        name: 'No Rune',
        tags: [cold, decay],
      },
      {
        name: 'The Spirit Is Willing',
        tags: [cold, resource, decay],
      },
      {
        name: 'Well of Souls',
        tags: [fire, decay],
      },
      {
        name: 'Phantasm',
        tags: [cold, dot, decay],
      },
      {
        name: 'Phlebotomize',
        tags: [cold, healing, decay],
      },
      {
        name: 'Manitou',
        tags: [cold, dot, decay],
      },
    ],
  },
  {
    name: 'Gargantuan',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, pet, voodoo],
      },
      {
        name: 'Humongoid',
        tags: [cold, pet, voodoo],
      },
      {
        name: 'Restless Giant',
        tags: [physical, pet, voodoo],
      },
      {
        name: 'Wrathful Protector',
        tags: [fire, cc, pet, voodoo],
      },
      {
        name: 'Big Stinker',
        tags: [poison, pet, voodoo],
      },
      {
        name: 'Bruiser',
        tags: [fire, cc, pet, voodoo],
      },
    ],
  },
  {
    name: 'Locust Swarm',
    runes: [
      {
        name: 'No Rune',
        tags: [poison, dot, secondary],
      },
      {
        name: 'Pestilence',
        tags: [poison, dot, secondary],
      },
      {
        name: 'Devouring Swarm',
        tags: [cold, dot, resource, secondary],
      },
      {
        name: 'Cloud of Insects',
        tags: [physical, dot, weaken, secondary],
      },
      {
        name: 'Diseased Swarm',
        tags: [poison, dot, secondary],
      },
      {
        name: 'Searing Locusts',
        tags: [fire, dot, secondary],
      },
    ],
  },
  {
    name: 'Firebomb',
    runes: [
      {
        name: 'No Rune',
        tags: [fire, primary],
      },
      {
        name: 'Flash Fire',
        tags: [fire, primary],
      },
      {
        name: 'Roll the Bones',
        tags: [fire, primary],
      },
      {
        name: 'Fire Pit',
        tags: [fire, dot, primary],
      },
      {
        name: 'Pyrogeist',
        tags: [fire, dot, primary],
      },
      {
        name: 'Ghost Bomb',
        tags: [cold, primary],
      },
    ],
  },
  {
    name: 'Hex',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, cc, defensive, physical],
      },
      {
        name: 'Hedge Magic',
        tags: [cooldown, healing, cc, defensive, cold],
      },
      {
        name: 'Jinx',
        tags: [cooldown, weaken, cc, defensive, poison],
      },
      {
        name: 'Angry Chicken',
        tags: [poison, mobility, cooldown, cc, defensive],
      },
      {
        name: 'Toad of Hugeness',
        tags: [poison, dot, cooldown, weaken, cc, defensive],
      },
      {
        name: 'Unstable Form',
        tags: [fire, cooldown, cc, defensive],
      },
    ],
  },
  {
    name: 'Acid Cloud',
    runes: [
      {
        name: 'No Rune',
        tags: [poison, dot, decay],
      },
      {
        name: 'Acid Rain',
        tags: [poison, dot, decay],
      },
      {
        name: 'Lob Blob Bomb',
        tags: [poison, dot, decay],
      },
      {
        name: 'Slow Burn',
        tags: [cold, dot, decay],
      },
      {
        name: 'Kiss of Death',
        tags: [poison, dot, decay],
      },
      {
        name: 'Corpse Bomb',
        tags: [fire, decay],
      },
    ],
  },
  {
    name: 'Mass Confusion',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, terror, cc, physical],
      },
      {
        name: 'Unstable Realm',
        tags: [cooldown, terror, cc, physical],
      },
      {
        name: 'Devolution',
        tags: [cooldown, pet, terror, cc, physical],
      },
      {
        name: 'Mass Hysteria',
        tags: [cooldown, terror, cc, physical],
      },
      {
        name: 'Paranoia',
        tags: [cooldown, weaken, terror, cc, physical],
      },
      {
        name: 'Mass Hallucination',
        tags: [physical, cooldown, terror, cc],
      },
    ],
  },
  {
    name: 'Big Bad Voodoo',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, damageBoost, mobility, physical],
      },
      {
        name: 'Jungle Drums',
        tags: [cooldown, damageBoost, mobility, physical],
      },
      {
        name: 'Rain Dance',
        tags: [cooldown, resource, damageBoost, mobility, physical],
      },
      {
        name: 'Slam Dance',
        tags: [cooldown, damageBoost, mobility, physical],
      },
      {
        name: 'Ghost Trance',
        tags: [cooldown, damageBoost, toughness, healing, mobility, physical],
      },
      {
        name: 'Boogie Man',
        tags: [cooldown, damageBoost, pet, mobility, physical],
      },
    ],
  },
  {
    name: 'Wall of Death',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, dot, cooldown, decay],
      },
      {
        name: 'Ring of Poison',
        tags: [poison, dot, cooldown, decay],
      },
      {
        name: 'Wall of Zombies',
        tags: [physical, dot, cc, cooldown, decay],
      },
      {
        name: 'Surrounded by Death',
        tags: [physical, dot, cooldown, decay],
      },
      {
        name: 'Fire Wall',
        tags: [fire, dot, cooldown, decay],
      },
      {
        name: 'Communing with Spirits',
        tags: [cold, dot, cc, weaken, cooldown, decay],
      },
    ],
  },
  {
    name: 'Fetish Army',
    runes: [
      {
        name: 'No Rune',
        tags: [physical, cooldown, pet, voodoo],
      },
      {
        name: 'Fetish Ambush',
        tags: [cold, cooldown, pet, voodoo],
      },
      {
        name: 'Devoted Following',
        tags: [physical, cooldown, pet, voodoo],
      },
      {
        name: 'Legion of Daggers',
        tags: [physical, cooldown, pet, voodoo],
      },
      {
        name: 'Tiki Torchers',
        tags: [fire, cooldown, pet, voodoo],
      },
      {
        name: 'Head Hunters',
        tags: [poison, cooldown, pet, voodoo],
      },
    ],
  },
  {
    name: 'Piranhas',
    runes: [
      {
        name: 'No Rune',
        tags: [cooldown, poison, weaken, decay],
      },
      {
        name: 'Bogadile',
        tags: [cooldown, physical, cc, weaken, decay],
      },
      {
        name: 'Zombie Piranhas',
        tags: [cooldown, poison, weaken, decay],
      },
      {
        name: 'Piranhado',
        tags: [cooldown, cc, poison, weaken, decay],
      },
      {
        name: 'Wave of Mutilation',
        tags: [cooldown, poison, weaken, decay],
      },
      {
        name: 'Frozen Piranhas',
        tags: [cooldown, cold, weaken, decay],
      },
    ],
  },
];
